import { AppCardBoxLoader, AppNotFoundBox } from "../../../../Libraries";
import { getProductById } from "../../../../../api";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { CreateProduct } from "..";

const EditProduct = () => {
    const { id } = useParams();

    const [loading, setLoading] = useState(true);
    const [item, setItem] = useState({});

    useEffect(() => {
        if (id) getProduct();
        else setLoading(false);
    }, [id]);

    const getProduct = async () => {
        try {
            const { data } = await getProductById(id);
            setItem(data.product);
        } catch (err) { }
        finally {
            setLoading(false);
        }
    };


    return loading ?
        <AppCardBoxLoader />
        : item?._id ?
            <CreateProduct from="edit" item={item} />
            :
            <AppNotFoundBox title='failed_to_load_product' />
};

export default EditProduct;